module.exports = __webpack_public_path__ + "img/ic-failed.d73145f7.svg";